<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="dialogVisible" width="800px" append-to-body>
    <el-input class="form-width-ms" v-model="queryForm.memberName" clearable placeholder="请输入会员名字" @change="getData"></el-input>
    <el-button size="mini" type="primary" @click="getData">搜索</el-button>
    <el-table @row-dblclick="confirms" :data= "list" @row-click="rowClick" max-height="600" v-loading="listLoading" class="margin-top-xs" :element-loading-text="elementLoadingText" :header-cell-style="{background: 'linear-gradient(#6cb3ff, #1873d4)' ,color:'#eeeeee'}">
      <el-table-column label="选择"   width="60">
        <template slot-scope="scope">
          <el-radio v-model="radio" :label="scope.row.id" @change.native="scope.row;">
            {{ "" }}
          </el-radio>
        </template>
      </el-table-column>   
      <el-table-column :show-overflow-tooltip="true" align="center" prop="memberNum" label="会员编码" min-width="120"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" prop="memberName" label="会员姓名" min-width="100"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" prop="sex" label="性别" min-width="60">
        <template slot-scope="scope">{{scope.row.sex==1?'男':'女'}}</template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" prop="mobilePhone" label="手机号码" min-width="120">
        <template slot-scope="scope">{{scope.row.mobilePhone | phone}}</template>
      </el-table-column>
      <el-table-column align="center" prop="label" label="备注" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column align="center" prop="memberStoreName" label="所属门店" min-width="140" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <el-pagination align="left" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.pageNum" :page-sizes="[10,20,30,40,50]" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirms()" :disabled="!radioForm.id">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { storeMemberpage } from "@/api/storeManage.js";
import { storeMemberOne } from "@/api/eashier.js";
export default {
  data() {
    return {
      radio: null, //单选值
      radioForm: {}, //单选对象
      list: [], //主数组
      dialogVisible: false, //弹窗开关
      title: "选择会员",
      listLoading: false, //list加载提示开启动画
      elementLoadingText: "数据加载中...", //list加载提示文字
      total: 0, //分页总条数
      queryForm: {
        //查询对象
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    //组件传值
    show(form) {
      this.staffList = [];
      if (form) {
        this.radio = form.id;
        this.radioForm = { ...form };
      } else {
        this.radio = null;
        this.radioForm = {};
      }
      this.dialogVisible = true;
      this.getData();
    },
    //点击选中
    rowClick(row) {
      this.radio = row.id;
      this.radioForm = row;
    },
    //分页方法
    handleSizeChange(val) {
      //   //console.log(`每页 ${val} 条`);
      this.queryForm.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //   //console.log(`当前页: ${val}`);
      this.queryForm.pageNum = val;
      this.getData();
    },
    //获取数据
    async getData() {
      this.queryForm.storeId = sessionStorage.getItem("parentId");
      this.queryForm.state = 1;
      this.listLoading = true;
      storeMemberpage(this.queryForm).then((res) => {
        this.listLoading = false;
        if (res.code == "000000") {
          this.list = res.pageInfo.list;
          this.total = res.pageInfo.total;
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    confirms() {
      this.radioForm.ratioShow = false;
      storeMemberOne({
        mobilePhone: this.radioForm.mobilePhone,
        storeId: sessionStorage.getItem("parentId"),
      }).then((res) => {
        if (res.code == "000000") {
          this.dialogVisible = false;
          this.$emit("memberData", res.data);
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/member/index.vue